import React, { useEffect, useRef, useState } from 'react';
import { VM } from '../../../viewmodel/VM';
import MapOptions from './mapOptions/MapOptions';
import { MapLeafLetContainer } from '../../maps/MapLeafLetContainer';
import ButtonIcon from '../../components/commons/ButtonIcon';
import { R } from '../../R';
import RouteUtils from '../../../utils/RouteUtils';
import { clickFav, favoritesInformation } from '../../../redux/slices/favoritesSlice';
import { useSelector } from 'react-redux';
import { useLanguage } from '../../context/languageContext';
import { lineSlice } from '../../../redux/slices/lineSlice';
import { useDispatch } from 'react-redux';
import LanguageSelector from '../accountscreen/language/LanguageSelector';
import { useResponsive } from '../../context/responsiveContext';
import { markersInformation } from '../../../redux/slices/markersSlice';
import { Apis } from '../../../domain/Apis';
import {
  useGetStationByIdMutation,
} from '../../../redux/login/explore/GbfsServiceApi';
import { useGoogleAnalytics } from '../../../utils/useGoogleAnalytics';
import { useSearchNoraMutation } from '../../../redux/login/search/SearchServiceApi';

export default function ExploreScreen(props) {
  const map = useRef();
  const [markerSelected, setMarkerSelected] = useState(null);
  const [showSecond, setShowSecond] = useState(true);
  const favorites = useSelector(favoritesInformation);
  const language = useLanguage();
  const elementClickFav = useSelector(clickFav);
  const dispatch = useDispatch();
  const responsive = useResponsive();
  const allMarkers = useSelector(markersInformation);
  const allStops = allMarkers.stops;
  const allStations = allMarkers.stopFathers;
  const [useGetStationsById] = useGetStationByIdMutation();
  const [searchNora] = useSearchNoraMutation();

  const { sendEventsOnMarkerClick } = useGoogleAnalytics();

  const sendAnalytics = async (marker) => {
    sendEventsOnMarkerClick({marker});
  };


  useEffect(() => {
    if (elementClickFav?.type == 'poi') onClickMarker(VM.pois.map[elementClickFav?.id]);
    else if (elementClickFav?.type == 'stop') onClickMarker(allStops.find((stop) => stop.id === elementClickFav?.id));
    else if (elementClickFav?.type == 'parent') { 
      const foundStopParent = allStations.find((stop) => stop.id === elementClickFav?.id);
      if (foundStopParent) {
        onClickMarker({...foundStopParent, ...{isParent: true}});
      }
    } else if (elementClickFav?.type == 'direction') onClickMarker(elementClickFav.id);
    else if (elementClickFav?.type == 'station') onClickMarker(elementClickFav.id);
    else if (elementClickFav?.type == 'lineSel') onClickLineSel(elementClickFav);
  }, [elementClickFav]);

  /* useEffect(() => {
    setMarkerSelected(null);
  }, [language]); */
  
  const getDirectionNameFromCoords = async (latitude, longitude) => {
    try {
      const result = await searchNora({
        locale: language,
        txt: `${latitude},${longitude}`,
      });

      const address = result?.data?.[0];

      if (!address) {
        return `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
      }

      const parts = [];

      if (address.via && address.via !== 'null') {
        parts.push(address.via);
      }

      if (address.street && address.street !== 'null') {
        parts.push(address.street);
      }

      if (address.portal && address.portal !== 'null') {
        parts.push(address.portal);
      }

      let resultText = parts.join(' ');

      const city = address.locality || address.municipality;

      if (city && city !== 'null') {
        resultText += `, ${city}`;
      }

      return resultText || `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
    } catch (error) {
      console.error('Error resolving coordinates', error);

      return `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
    }
  };

  const onClick = async (e) => {
    let coords = { latitude: e.latlng.lat, longitude: e.latlng.lng };
    let name = e?.latlng.lat.toFixed(6) + ', ' + e.latlng.lng.toFixed(6);
    let info = RouteUtils.getTypeId(e, favorites, name);
    
    if (info.typeId === 3) {
      name = await getDirectionNameFromCoords(
        coords.latitude,
        coords.longitude,
      );
    }

    let res = { name: name, coords: coords, typeId: info.typeId, value: info.value };

    console.log("res: ", res)

    if (!VM.plannerSegments.data['destination']) {
      VM.plannerSegments.set('destination', res);
    } else if (!VM.plannerSegments.data['origin']) {
      VM.plannerSegments.set('origin', res);
    } else {
      VM.plannerSegments.add(res);
    }
  };

  const onDblClick = (e, map) => {
    let res = {
      latitude: e.latlng.lat,
      longitude: e.latlng.lng,
      double: true,
      name: e.latlng.lat.toFixed(6) + ', ' + e.latlng.lng.toFixed(6)
    };
    map.flyTo(e.latlng);
    setMarkerSelected(res);
    VM.lines.setSelected(null);
    sendAnalytics(res);
  };

  const onClickMarker = (markRead, mapRef, zoom, sendAnalyticsOnclick = false) => {
    let marker = JSON.parse(JSON.stringify(markRead));
    
    VM.screenSelected.setSelected('explore');
    //TO CHANGE
    if (marker?.agencyOriginId)
      marker.agencyOriginId = VM.stops.map[marker?.id]?.agencyOriginId ?? marker?.agencyOriginId;
    map.current.flyTo({ lat: marker.latitude, lng: marker.longitude }, zoom ? zoom : 14.5);
    setTimeout(
      () =>
        map.current.flyTo({ lat: marker.latitude, lng: marker.longitude }, zoom ? zoom + 0.5 : 15),
      1000
    );
    sendAnalyticsOnclick && sendAnalytics(marker);
    setMarkerSelected(marker);
    VM.lines.setSelected(null);
  };

  const onClickLineSel = (markerStop) => {
    map.current.flyTo({ lat: markerStop.latitude, lng: markerStop.longitude }, 14.5);
  };

  return (
    <div>
      <MapOptions
        showSecond={showSecond}
        setShowSecond={setShowSecond}
        setOpen={props.setOpen}
        markerSelected={markerSelected}
        setMarkerSelected={setMarkerSelected}
        onClickMarker={onClickMarker}
      />
      {responsive.isMobile ? null : <LanguageSelector />}
      <MapLeafLetContainer
        ref={map}
        markerSelected={markerSelected}
        onClickMarker={(params, map, zoom, sendAnalyticsOnclick) => {
          onClickMarker(params, map, zoom, sendAnalyticsOnclick);
          dispatch(lineSlice.actions.updateFilteredLine(null));
        }}
        onDblClick={onDblClick}
        onClick={onClick}
      />
      <div className={'leaflet-control-layer'}>
        <ButtonIcon
          icon={R.drawables.general.Ic_map}
          size={50}
          onClick={() => {
            let newMapType =
              localStorage.getItem('mapType') === null
                ? 0
                : parseInt(localStorage.getItem('mapType'));
            localStorage.setItem('mapType', newMapType ? 0 : 1);
            window.location.reload(false);
          }}
        />
      </div>
    </div>
  );
}
export const MemoExploreScreen = React.memo(ExploreScreen);
